<button mat-raised-button [color]="color" [disabled]="disabled">
  {{ text }}
</button>
